<template>
  <div id="app">
    <div  :style="( fixedIt === true ? 'width: -webkit-fill-available;position:fixed;' : '' )" >
      <app-header></app-header>
      
      <router-view />
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import appHeader from './components/AppHeader.vue'
import appFooter from './components/AppFooter.vue'

export default {
  components: {
    'app-header': appHeader,
    'app-footer': appFooter,
  },
  computed: {
    fixedIt() {
      console.log(this.$store.getters.fixedMain);
      return this.$store.getters.fixedMain;
    },
  },
  mounted(){
    let jquery = document.createElement('script');
    jquery.setAttribute('type', 'text/javascript');
    jquery.setAttribute('src', 'https://data.pixcham.com/scripts/financial.js');
    document.head.appendChild(jquery);
  },
  methods: {
    hasAccess() {
      return this.$store.getters.userPrivileges;
    }
  }
}
</script>
<style>
  @import './assets/styles/main.css';
</style>